import React from 'react';

const SingleWork = (props) => {
    return (
       
            <img src={props.work.img} alt='' />
     
    );
};

export default SingleWork;